import {
	ADD_PLAYS_COMPLETE,
	APPLY_FILTER,
	CREATE_START_PLAYS_COMPLETE,
	DELETE_PLAY_COMPLETE,
	END_PLAY,
	FINALIZE_PLAY_COMPLETE,
	GET_PLAY_COMPLETE,
	GO_BACK_COMPLETE,
	GO_BACK_TO_COMPLETE,
	GO_FORWARD_COMPLETE,
	INIT_PLAYS_DATA,
	INIT_PLAYS_DATA_COMPLETE,
	SAVE_EDIT_PLAY,
	SAVE_EDIT_PLAY_COMPLETE,
	SAVE_FRAGMENT,
	SAVE_FRAGMENT_COMPLETE,
	SAVE_PLAY_COMPLETE,
	SET_ACTIVE_STEP,
	SET_SHOW_DATA_SELECTORS,
	START_FOOTBALL_GAME_COMPLETE,
	START_OVER,
	START_PLAY,
	START_TRANSITION,
	START_TRANSITION_COMPLETE,
	TOGGLE_EDIT_PLAY_MODE,
	REFRESH_PLAYS_COMPLETE,
	GAME_CONTROL,
	UPDATE_PLAY_STATE,
	INSERT_PLAY_COMPLETE,
	UPDATE_STEPS,
	REFRESH_PARTICIPANTS,
	REFRESH_PARTICIPANTS_COMPLETE,
	REVERT_TO_TRANSITION,
	REVERT_TO_TRANSITION_COMPLETE
} from "./constants";

const initialState = {
	plays: [],
	filteredPlays: [],
	searchText: null,
	currentPlay: null,
	currentState: null,
	playHistory: [],
	transitionHistory: [],
	isLoading: false,
	allowedTransitions: [],
	canGoBack: false,
	canGoForward: false,
	metadata: null,
	isTransitioning: false,
	// WIZARD
	steps: [],
	activeStep: 0
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case INIT_PLAYS_DATA:
		case SAVE_EDIT_PLAY:
		case SAVE_FRAGMENT: {
			return {
				...state,
				isLoading: true
			};
		}
		case INIT_PLAYS_DATA_COMPLETE: {
			return {
				...state,
				...payload,
				isLoading: false
			};
		}
		case GO_BACK_TO_COMPLETE:
		case SET_SHOW_DATA_SELECTORS:
		case APPLY_FILTER:
		case UPDATE_PLAY_STATE:
		case START_OVER:
		case END_PLAY:
		case TOGGLE_EDIT_PLAY_MODE:
		case UPDATE_STEPS:
		case GET_PLAY_COMPLETE:
		case SAVE_PLAY_COMPLETE:
		case GO_FORWARD_COMPLETE:
		case GO_BACK_COMPLETE:
		case INSERT_PLAY_COMPLETE:
		case START_PLAY: {
			return {
				...state,
				...payload,
				isTransitioning: false
			};
		}
		case ADD_PLAYS_COMPLETE: {
			const { plays } = payload;

			return {
				...state,
				plays: [...plays, ...state.plays],
				filteredPlays: [...plays, ...state.filteredPlays]
			};
		}
		case REFRESH_PLAYS_COMPLETE: {
			const { plays } = payload;
			return {
				...state,
				plays,
				filteredPlays: state.searchText
					? state.filteredPlays
							.filter((fp) => plays.some((p) => p.index === fp.index))
							.map((p) => plays.find((np) => np.index === p.index))
					: plays
			};
		}
		case DELETE_PLAY_COMPLETE: {
			const { playId } = payload;
			return {
				...state,
				plays: state.plays.filter((p) => p.id !== playId),
				filteredPlays: state.filteredPlays.filter((p) => p.id !== playId)
			};
		}
		case GAME_CONTROL:
		case REVERT_TO_TRANSITION:
		case START_TRANSITION: {
			return {
				...state,
				isTransitioning: true
			};
		}
		case CREATE_START_PLAYS_COMPLETE:
		case REVERT_TO_TRANSITION_COMPLETE:
		case START_TRANSITION_COMPLETE:
		case START_FOOTBALL_GAME_COMPLETE: {
			const { createdPlays, ...rest } = payload;

			return {
				...state,
				...rest,
				isTransitioning: false,
				plays: [...createdPlays, ...state.plays],
				filteredPlays: [...createdPlays, ...state.filteredPlays]
			};
		}
		case FINALIZE_PLAY_COMPLETE: {
			const { createdPlays, ...rest } = payload;

			return {
				...state,
				...rest,
				plays: [...createdPlays, ...state.plays],
				filteredPlays: [...createdPlays, ...state.filteredPlays]
			};
		}
		case SAVE_EDIT_PLAY_COMPLETE: {
			const { play } = payload;

			return {
				...state,
				plays: state.plays.map((p) => {
					return p.id !== play.id ? p : play;
				}),
				filteredPlays: state.filteredPlays.map((p) => {
					return p.id !== play.id ? p : play;
				})
			};
		}
		case SAVE_FRAGMENT_COMPLETE: {
			return {
				...state,
				...payload
			};
		}
		case REFRESH_PARTICIPANTS:
		case REFRESH_PARTICIPANTS_COMPLETE:
		case SET_ACTIVE_STEP: {
			return {
				...state,
				...payload
			};
		}
		default:
			return state;
	}
};

export default reducer;
